import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Empresa } from 'src/app/dashboard/models/empresa';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { EmpresaService } from 'src/app/dashboard/services/empresa.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css']
})
export class EmpresasComponent implements OnInit {
  sociedad: string;
  empresas: Empresa[] = [];
  validatingForm: FormGroup;
  IsHiddenForm = false;

  id_empresa: string;
  n_empresa: string;
  comentario: string;

  constructor(
    private empresaService: EmpresaService,
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private changeDetectorRefs: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);
    this.sociedad = this.auth.getNameSociedad();

    this.loadEmpresas();

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalOrden: new FormControl('', [
        Validators.pattern(/^\d+$/),
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
    });
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalOrden() {
    return this.validatingForm.get('signupFormModalOrden');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  loadEmpresas() {
    this.apiService.searchCompanyByUser(this.auth.getSociedad())
      .subscribe({
        next: (res) => {
          if (res.code === 200 && res.success) {
            this.empresas = res.data;
          }
        },
        error: (err) => {
          if (err.error.code === 404 && !err.error.success) {
            this.toastr.error(this.translate.instant('texto_912'));
          } else {
            this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'))
          }
        }
      });
  }

  deleteCompany(id_empresa: string) {
    this.empresaService.countComplaintByIdCompany(this.auth.getSociedad(), id_empresa).subscribe(res => {
      if (res === 200) {
        this.empresaService.deleteCompanyByUser(this.auth.getSociedad(), id_empresa).subscribe(res => {
          if ((res as any)?.success === true) {
            this.toastr.success(this.translate.instant('texto_276'), this.translate.instant('texto_279'));
          } else {
            this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_279'));
          }
          this.reloadComponent();
        },
          err => {
            if (err.status === 409) {
              this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_813'));
            } else {
              this.toastr.error(this.translate.instant('texto_277'), this.translate.instant('texto_813'));
            }
          });
      } else {
        this.toastr.error(this.translate.instant('texto_278'), this.translate.instant('texto_279'));
        this.reloadComponent();
      }
    });
  }

  showCompany(empresa: Empresa) {
    this.IsHiddenForm = true;
    this.id_empresa = empresa.id_empresa;
    this.n_empresa = empresa.n_empresa;
    this.comentario = empresa.comentario;

    this.validatingForm.patchValue({
      signupFormModalId: empresa.id_empresa,
      signupFormModalName: empresa.n_empresa,
      contactFormModalMessage: empresa.comentario
    });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  updateCompany(id_empresa: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    const name = this.signupFormModalName?.value || '';
    const comment = this.contactFormModalMessage?.value || 'Sin comentarios';

    this.empresaService.updateCompanyByUser(this.auth.getSociedad(), id_empresa, name, comment).subscribe(res => {
      if ((res as any)?.success === true) {
        this.toastr.success(this.translate.instant('texto_280'), this.translate.instant('texto_282'));
      } else {
        this.toastr.error(this.translate.instant('teato_281'), this.translate.instant('texto_282'));
      }
      this.reloadComponent();
    },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('teato_281'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('teato_281'), this.translate.instant('texto_813'));
        }
      });
  }

  reloadComponent() {
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/dashboard/layout/empresas']);
    });
  }

  getSociedad() {
    return localStorage.getItem("sociedad");
  }
}
